import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@shared/auth/useAuth';

export function CallbackScreen() {
  const navigate = useNavigate();
  const { authMode, completeSignin } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    async function run() {
      try {
        if (authMode === 'zitadel') {
          await completeSignin(window.location.href);
        }
        navigate('/inventory', { replace: true });
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Sign-in failed');
      }
    }

    void run();
  }, [authMode, completeSignin, navigate]);

  if (error) {
    return (
      <div role="alert" style={{ padding: 24 }}>
        <h1>Sign-in failed</h1>
        <p>{error}</p>
        <button type="button" onClick={() => navigate('/login', { replace: true })}>
          Back to login
        </button>
      </div>
    );
  }

  return <div style={{ padding: 24 }}>Completing sign-in…</div>;
}
